import React from 'react';
import Component from '@vfuk/core-icon';
const Icon = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Icon;
